function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12.5,
  cy: 12.5,
  r: 12.5,
  fill: "#FF9400",
  fillOpacity: 0.2
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5 7.8V5L9.0625 8.5L12.5 12V9.2C14.7756 9.2 16.625 11.083 16.625 13.4C16.625 15.717 14.7756 17.6 12.5 17.6C10.2244 17.6 8.375 15.717 8.375 13.4H7C7 16.494 9.46125 19 12.5 19C15.5387 19 18 16.494 18 13.4C18 10.306 15.5387 7.8 12.5 7.8Z",
  fill: "#FF9400"
});
const SvgInProgressIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};
const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgInProgressIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/in-progress-icon.544889f9.svg";
export { ForwardRef as ReactComponent };